// Generated by ReScript, PLEASE EDIT WITH CARE


let defaultDict = {};

export {
  defaultDict,
}
/* No side effect */
